// type
import type { Components, Theme } from "@mui/material";

export const MuiAppBar: Components<Theme>["MuiAppBar"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: "transparent",
      boxShadow: "none",
    }),
  },
};
